import { MessageSquare } from 'lucide-react';

interface Props {
    count: number;
    /** When set, the badge is its own click target (stops propagation). */
    onClick?: () => void;
    className?: string;
}

/**
 * Small comment indicator (icon + count). Renders nothing when there are no
 * comments, so it stays out of the way on rows without notes.
 */
export function CommentBadge({ count, onClick, className }: Props) {
    if (!count || count <= 0) return null;

    const base = `inline-flex items-center gap-0.5 rounded-full bg-amber-50 px-1.5 py-0.5 text-xs font-medium text-amber-700 ${className ?? ''}`;

    if (onClick) {
        return (
            <button
                type="button"
                onClick={(e) => { e.stopPropagation(); onClick(); }}
                title={`${count} comment${count === 1 ? '' : 's'}`}
                className={`${base} hover:bg-amber-100`}
            >
                <MessageSquare className="h-3 w-3" />
                {count}
            </button>
        );
    }

    return (
        <span title={`${count} comment${count === 1 ? '' : 's'}`} className={base}>
            <MessageSquare className="h-3 w-3" />
            {count}
        </span>
    );
}
